import { RouteConfig } from 'vue-router'

interface MenuRouteOptions {
	rules: string[] | undefined
	exact: boolean
}

export class MenuRoute {
	text: string
	rules: string[] | undefined
	to: RouteConfig
	exact: boolean = true
	prependIcon: string
	isActive: boolean = false
	children: Array<MenuRoute> | undefined
	tag: string

	constructor(
		text: string,
		icon: string,
		route: string,
		options: MenuRouteOptions,
		children: Array<MenuRoute> | undefined = undefined,
		tag: string = ''
	) {
		this.text = text
		this.prependIcon = icon
		this.to = { name: route } as RouteConfig
		this.rules = options.rules
		this.exact = options.exact
		this.isActive = false
		this.children = children
		this.tag = tag
	}
}
